import useApiFetchV2 from "../useApiFetchV2";

export interface Customization {
    logo: string;
    app_name: string;
    app_color_primary: string;
    app_color_secondary: string;
    app_color_on_primary: string;
    app_color_on_secondary: string;
}

export interface Settings {
    about: string;
    rules: string;
    app_phone: string;
    app_facebook_url: string;
    app_whatsapp_url: string;
    app_telegram_url: string;
    app_twitter_url: string;
    app_instagram_url: string;
    app_website_url: string;
    app_email_url: string;
    app_google_play_url: string;
    app_app_store_url: string;
}

export interface Meta {
    domain: string;
    page_size: string;
    api_version: string;
    project_name: string;
    customization: Customization;
    settings: Settings;
    service_providers_super_parent_id: string;
    users_super_parent_id: string;
    cards_super_parent_id: string;
    expenses_super_parent_id: string;
}



export default function () {
    return useApiFetchV2<Meta>('meta', undefined, {
        refreshInterval: 60000,
    })
}
